/*!
 * This file was created to avoid "values imports" (constants/enums/classes/etc.) from the `shaka-player@4.15.0`
 * to avoid including the whole package in our distribution code.
 *
 * Because `shaka-player` npm package is not installed, because it has bad TypeScript definitions
 * @see https://github.com/shaka-project/shaka-player/issues/6442)
 * - we can't use "type imports" (`import type {}`),
 * - we can't cover copies of the library values with unit tests
 *
 * Shaka discussion about migration to TypeScript
 * @see https://github.com/shaka-project/shaka-player/issues/8262
 */

export const ShakaPlayerEvent = {
  /**
   * Fired when the player unloads or fails to load. Used by the Cast receiver to determine idle state.
   * @see https://shaka-player-demo.appspot.com/docs/api/shaka.Player.html#.event:UnloadingEvent
   */
  UNLOADING: 'unloading',
  /**
   * Fired when the player changes load states.
   * @see https://shaka-player-demo.appspot.com/docs/api/shaka.Player.html#.event:StateChangeEvent
   */
  ONSTATECHANGE: 'onstatechange',
  /**
   * Fired when player state is changed.
   * @see https://shaka-player-demo.appspot.com/docs/api/shaka.Player.html#.event:StateChanged
   */
  STATECHANGED: 'statechanged',
  /**
   * Fired when the player's buffering state changes.
   * @see https://shaka-player-demo.appspot.com/docs/api/shaka.Player.html#.event:BufferingEvent
   */
  BUFFERING: 'buffering',
  /**
   * Fired when a playback error occurs.
   * @see https://shaka-player-demo.appspot.com/docs/api/shaka.Player.html#.event:ErrorEvent
   */
  ERROR: 'error',
} as const;

/**
 * @see https://shaka-player-demo.appspot.com/docs/api/shaka.util.Error.html
 */
export type ShakaErrorEvent = Error & {
  category: number;
  code: number;
  severity: number;
};
